<template>
  <div class="theme_container" id="theme"></div>
</template>

<script>
import * as echarts from "echarts";
export default {
  name: "theme_container",
  props: {
    themeData: {
      type: Object,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      datax: [],
      legendData: [],
    };
  },
  watch: {
    themeData(val) {
      // this.datax = val.conceptYearCountList;
      this.datax = val.newYearCountList;
      this.legendData = val.top5Concepts;
      // this.legendData = ["Bacteria"];
      this.getOption();
    },
  },
  computed: {},
  mounted() {
    this.getOption();
  },
  methods: {
    getOption() {
      // 避免 document.getElementById 在微前端或切换路由时获取不到 DOM 报错
      let chartDom = document.getElementById("theme") || this.$el;
      if (!chartDom) return;
      let myChart = echarts.init(chartDom);
      let option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "line",
            lineStyle: {
              color: "rgba(0,0,0,0.2)",
              width: 1,
              type: "solid",
            },
          },
        },
        legend: {
          data: this.legendData,
        },
        singleAxis: {
          top: 50,
          bottom: 50,
          type: "time",
          axisTick: {
            show: false, // 不显示坐标轴刻度线
          },
          axisLine: {
            show: false, // 不显示坐标轴线
          },
          axisLabel: {
            show: false, // 不显示坐标轴上的文字
          },
          splitLine: {
            show: false, // 不显示网格线
          },
          axisPointer: {
            animation: true,
            label: {
              show: true,
            },
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: "dashed",
              opacity: 0.2,
            },
          },
        },

        series: [
          {
            type: "themeRiver",

            emphasis: {
              itemStyle: {
                shadowBlur: 20,
                shadowColor: "rgba(0, 0, 0, 0.8)",
              },
            },
            label: {
              show: false,
            },
            data: this.datax,
          },
        ],
      };
      myChart.setOption(option);
    },
  },
};
</script>

<style lang="scss" scope>
.theme_container {
  width: 100%;
  height: 340px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
</style>
